// ISO 3166-1 alpha-2 country codes. Names are resolved via Intl.DisplayNames so we
// never hand-maintain a name list — only the fixed code list needs to exist here.
export const COUNTRY_CODES = [
  "US", "CA", "GB", "AU", "NZ", "IE", "IN", "AE", "SG", "ZA",
  "AF", "AL", "DZ", "AR", "AM", "AT", "AZ", "BH", "BD", "BY",
  "BE", "BZ", "BJ", "BT", "BO", "BA", "BW", "BR", "BN", "BG",
  "BF", "BI", "KH", "CM", "CV", "CF", "TD", "CL", "CN", "CO",
  "KM", "CG", "CD", "CR", "HR", "CU", "CY", "CZ", "DK", "DJ",
  "DM", "DO", "EC", "EG", "SV", "GQ", "ER", "EE", "SZ", "ET",
  "FJ", "FI", "FR", "GA", "GM", "GE", "DE", "GH", "GR", "GD",
  "GT", "GN", "GW", "GY", "HT", "HN", "HK", "HU", "IS", "ID",
  "IR", "IQ", "IL", "IT", "JM", "JP", "JO", "KZ", "KE", "KI",
  "KW", "KG", "LA", "LV", "LB", "LS", "LR", "LY", "LI", "LT",
  "LU", "MO", "MG", "MW", "MY", "MV", "ML", "MT", "MH", "MR",
  "MU", "MX", "FM", "MD", "MC", "MN", "ME", "MA", "MZ", "MM",
  "NA", "NR", "NP", "NL", "NI", "NE", "NG", "MK", "NO", "OM",
  "PK", "PW", "PA", "PG", "PY", "PE", "PH", "PL", "PT", "QA",
  "RO", "RU", "RW", "KN", "LC", "VC", "WS", "SM", "ST", "SA",
  "SN", "RS", "SC", "SL", "SK", "SI", "SB", "SO", "ES", "LK",
  "SD", "SR", "SE", "CH", "SY", "TW", "TJ", "TZ", "TH", "TL",
  "TG", "TO", "TT", "TN", "TR", "TM", "TV", "UG", "UA", "UY",
  "UZ", "VU", "VA", "VE", "VN", "YE", "ZM", "ZW",
];

const displayNames = (() => {
  try {
    return new Intl.DisplayNames(["en"], { type: "region" });
  } catch {
    return null;
  }
})();

export const getCountryName = (code) => {
  if (!displayNames) return code;
  try {
    return displayNames.of(code) || code;
  } catch {
    return code;
  }
};

export const COUNTRIES = COUNTRY_CODES
  .map((code) => ({ code, name: getCountryName(code) }))
  .sort((a, b) => a.name.localeCompare(b.name));

export const STATES_BY_COUNTRY = {
  US: [
    "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", "Connecticut",
    "Delaware", "District of Columbia", "Florida", "Georgia", "Hawaii", "Idaho", "Illinois",
    "Indiana", "Iowa", "Kansas", "Kentucky", "Louisiana", "Maine", "Maryland", "Massachusetts",
    "Michigan", "Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada",
    "New Hampshire", "New Jersey", "New Mexico", "New York", "North Carolina", "North Dakota",
    "Ohio", "Oklahoma", "Oregon", "Pennsylvania", "Rhode Island", "South Carolina",
    "South Dakota", "Tennessee", "Texas", "Utah", "Vermont", "Virginia", "Washington",
    "West Virginia", "Wisconsin", "Wyoming",
  ],
  CA: [
    "Alberta", "British Columbia", "Manitoba", "New Brunswick", "Newfoundland and Labrador",
    "Northwest Territories", "Nova Scotia", "Nunavut", "Ontario", "Prince Edward Island",
    "Quebec", "Saskatchewan", "Yukon",
  ],
  IN: [
    "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh", "Goa", "Gujarat",
    "Haryana", "Himachal Pradesh", "Jharkhand", "Karnataka", "Kerala", "Madhya Pradesh",
    "Maharashtra", "Manipur", "Meghalaya", "Mizoram", "Nagaland", "Odisha", "Punjab",
    "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana", "Tripura", "Uttar Pradesh", "Uttarakhand",
    "West Bengal", "Delhi", "Jammu and Kashmir", "Ladakh", "Puducherry", "Chandigarh",
  ],
  AU: [
    "New South Wales", "Queensland", "South Australia", "Tasmania", "Victoria",
    "Western Australia", "Australian Capital Territory", "Northern Territory",
  ],
};

export const hasStateList = (countryCode) => Boolean(STATES_BY_COUNTRY[countryCode]);
